import { Component, Mixins } from "vue-property-decorator";
import BrandCurrencyId from "@/mixins/brandCurrencyId";
import AdminBrandId from "@/mixins/adminBrandId";
import BrandCurrencies from "@/mixins/brandCurrencies";
import Context from "@/mixins/context";
import CurrenciesStore from "@/mixins//constants/currenciesStore";
import { STATS_ALL_CURRENCY_CODE } from "@/data/constants";

@Component
export default class StatsCurrencyMixin extends Mixins(
  BrandCurrencies,
  BrandCurrencyId,
  CurrenciesStore,
  AdminBrandId,
  Context
) {
  // Methods
  public async getStatsDefaultCurrencyCode() {
    await this.$store.dispatch("constants/getCurrencies");

    if (this.isClient) {
      if (this.brandCurrencies.length === 0)
        return (
          this.currencies.find(c => c.id === this.brandCurrencyId)?.code ||
          STATS_ALL_CURRENCY_CODE
        );
      else if (this.brandCurrencies.length)
        return (
          this.brandCurrencies.find(i => i.id === this.brandCurrencyId)?.code ||
          STATS_ALL_CURRENCY_CODE
        );
    } else if (this.isAdmin) {
      if (this.brandCurrencies.length === 0)
        return (
          this.currencies.find(c => c.id === this.brandCurrencyId)?.code ||
          STATS_ALL_CURRENCY_CODE
        );
      else if (this.brandCurrencies.length === 1)
        return this.brandCurrencies[0]?.code || STATS_ALL_CURRENCY_CODE;
      return STATS_ALL_CURRENCY_CODE;
    }

    return null;
  }
}
